"use client";
import ProductSection from "@/app/components/common/sections/ProductSection";
import { Product } from "@/app/lib/features/product/product.types";

interface StoreProductsSectionProps {
  title: string;
  viewAllUrl?: string;
  products: Product[];
}

const StoreProductsSection = ({
  title,
  viewAllUrl,
  products,
}: StoreProductsSectionProps) => {
  if (!products.length) return null;

  return (
    <ProductSection
      title={title}
      products={products}
      linkUrl={viewAllUrl}
      showViewAll={!!viewAllUrl}
    />
  );
};

export default StoreProductsSection;
